var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEypaIicon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9073 17.6818C19.9073 18.9325 18.8904 19.9499 17.6403 19.9499H13.0561C11.806 19.9499 10.7891 18.9325 10.7891 17.6818V13.0953C10.7891 11.8446 11.806 10.8271 13.0561 10.8271H17.6403C18.8904 10.8271 19.9073 11.8446 19.9073 13.0953V17.6818Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18801 13.0967V17.7161C9.18801 18.9754 8.1639 20 6.90522 20H2.28815C1.02947 20 0.00537109 18.9754 0.00537109 17.7161V13.0967C0.00537109 11.8374 1.02947 10.8128 2.28815 10.8128H6.90522C7.96223 10.8128 8.96345 10.5724 9.85883 10.1431C9.42974 11.0389 9.18944 12.0406 9.18944 13.0981L9.18801 13.0967Z",
    fill: "#CDCDCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90414 0.0327148H2.28422C1.02268 0.0327148 0 1.0559 0 2.31806V6.94027C0 8.20243 1.02268 9.22562 2.28422 9.22562H6.90414C8.16568 9.22562 9.18836 8.20243 9.18836 6.94027V2.31806C9.18836 1.0559 8.16568 0.0327148 6.90414 0.0327148Z",
    fill: "#1A9AFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 6.91901C19.9999 8.18118 18.9729 9.20866 17.7114 9.20866H13.0843C12.0259 9.20866 11.0218 9.4505 10.125 9.87981C10.5555 8.98255 10.7958 7.9794 10.7958 6.91901V2.28964C10.7958 1.02748 11.8228 0 13.0843 0H17.7114C18.9729 0 19.9999 1.02748 19.9999 2.28964V6.91901Z",
    fill: "#CDCDCD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEypaIicon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EYPAIicon.086ee746dedf3643f0dba69e91816982.svg";